module.exports = __webpack_public_path__ + "static/media/neutral.12561dbd.png";